export default "__VITE_ASSET__CEnTQ9f4__"